module.exports = __webpack_public_path__ + "static/img/ph01.226830a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/video-archive/ph01.jpg
// module id = oNRA
// module chunks = 0